import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorBirthday = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M7 4.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM7.181 13a1.716 1.716 0 1 1-3.431 0 .75.75 0 0 0-1.5 0 3.216 3.216 0 0 0 5.513 2.25 4.795 4.795 0 0 0 8.506.033A3.216 3.216 0 0 0 21.75 13a.75.75 0 0 0-1.499 0 1.716 1.716 0 0 1-3.43.065v-.016l-.001-.043V13a.75.75 0 0 0-1.5 0v.084a3.296 3.296 0 0 1-6.59-.035c0-.215-.09-.409-.236-.546A.748.748 0 0 0 7.181 13ZM13 3.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM17 4.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M7.75 6a.75.75 0 0 0-1.5 0v2.25H6A3.75 3.75 0 0 0 2.25 12v7.25H1a.75.75 0 0 0 0 1.5h22a.75.75 0 0 0 0-1.5h-1.25V12A3.75 3.75 0 0 0 18 8.25h-.25V6a.75.75 0 0 0-1.5 0v2.25h-3.5V6a.75.75 0 0 0-1.5 0v2.25h-3.5V6ZM6 9.75h12A2.25 2.25 0 0 1 20.25 12v7.25H3.75V12A2.25 2.25 0 0 1 6 9.75Z"
    />
  </svg>
);
export default SvgTwoColorBirthday;
